import { StoreInterface } from "../../models";

export const getAllUsers = (state: StoreInterface) => state?.users?.users;
export const getDeleteUserId = (state: StoreInterface) => state?.users?.deleteUserId;
